import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 408.25 277.18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M102.5 255.18h.25c.1 0 .22-.11.3-.27 2.37-4.48 4.83-8.92 7.38-13.31 4.67-8.01 13.82-16.22 21.41-21.71 4.42-3.19 8.46-6.72 13.2-9.04 15.09-7.41 31.17-10.61 48.24-9.62.27.02.51-.2.52-.47.05-2.22-.79-4.26-2.51-6.13-6.98-7.59-11.9-14.14-19.6-19.18-5.47-3.57-11.19-6.69-17.16-9.35-5.31-2.36-11.04-3.48-16.8-4.66-.55-.11-.63-.38-.25-.79 7.98-8.73 15.76-17.74 24.26-25.73 5.18-4.87 10.39-9.7 15.63-14.5 10.36-9.5 22.72-16.99 34.48-24.58 6.48-4.18 14.06-6.65 21-10.4 4.25-2.29 7.86-4 10.81-5.11 22.05-8.31 45.82-15.56 69.26-18.46 32.84-4.05 62.86-3.92 94.07-3.64 1.47 0 1.65.5.54 1.46-8.9 7.76-18.01 15.27-27.32 22.52-82.26 64.07-163.48 129.46-244.83 194.68-.24.19-.55.29-.88.29H.5c-.28 0-.5-.22-.5-.5V.93C0-.08.39-.27 1.16.37c10.72 8.86 21.39 19.77 30.39 30.38 7.63 8.98 15.46 17.97 22 27.33 9.38 13.41 18.27 26.94 25.36 41.74 12.11 25.27 20.03 51.73 23.76 79.38.77 5.73 1.21 12.37 1.3 19.92.28 21.25.11 35.39-1.86 55.57-.03.26.15.48.39.49Z",
      style: {"fill":"#ed6400"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "V0-logo"}) } }